export const CourseRankingSort = Object.freeze(
  {
     Enrollments:0,   // default
     Price:1,
     EstimatedTime:2,
     Latest:3
  })